// Бэк после входа через KTSID всегда возвращает на главную — это старый учёт, которому нужен
// токен Яндекса. Отметка в sessionStorage переживает уход к провайдеру и говорит главной увести
// в новый учёт. sessionStorage бывает недоступен (приватный режим) — тогда просто остаёмся на главной

const KTSID_LOGIN_KEY = 'ktsidLogin';

export const markKtsidLogin = () => {
  try {
    sessionStorage.setItem(KTSID_LOGIN_KEY, '1');
  } catch {
    // без отметки попадём на главную, как раньше
  }
};

export const hasKtsidLoginMark = (): boolean => {
  try {
    return sessionStorage.getItem(KTSID_LOGIN_KEY) === '1';
  } catch {
    return false;
  }
};

export const clearKtsidLoginMark = () => {
  try {
    sessionStorage.removeItem(KTSID_LOGIN_KEY);
  } catch {
    // нечего чистить
  }
};
